@if (iconName && isVisible) {
  <div
    id="icam-container"
    [@fadeIn]
    [ngClass]="{
      'light-container': fixedTheme === 'light' || (!fixedTheme && isLight),
      'dark-container': fixedTheme === 'dark' || (!fixedTheme && !isLight)
    }"
  >
    @if (centralIcon) {
      <div class="icon-container" [style.background-color]="iconColor" [ngClass]="{ 'central-icon': centralIcon }">
        <app-icam-icon
          iconName="{{ iconName }}"
          iconColor="{{ iconColor }}"
          [isDefault]="true"
          [iconHeight]="iconHeight || '20px'"
        />
      </div>
    }
    @if (!centralIcon) {
      <div class="icon-container" [ngClass]="{ 'light-container': isLight, 'dark-container': !isLight }">
        <app-icam-icon iconName="{{ iconName }}" iconColor="{{ iconColor }}" [isDefault]="!!fixedTheme" />
      </div>
    }
    @if (isClosable) {
      <div class="close-container">
        <span
          class="close-button"
          (click)="closeContainer()"
          (keydown.enter)="closeContainer()"
          tabindex="0"
          role="button"
          >x {{ 'COMMON.CLOSE' | translate }}</span
        >
      </div>
    }
    @if (isExpandable) {
      <div class="close-container">
        <span
          class="close-button"
          (click)="toggleExpanded()"
          (keydown.enter)="toggleExpanded()"
          tabindex="0"
          role="button"
          >{{ (isExpanded ? 'COMMON.SHOW_LESS' : 'COMMON.SHOW_MORE') | translate }}</span
        >
      </div>
    }
  </div>
}
@if (isVisible) {
  <div
    class="margin-container"
    [@fadeIn]
    [ngClass]="{
      'light-container': isLight,
      'dark-container': !isLight,
      'adjust-padding': !iconName,
      'full-radius': !iconName
    }"
  >
    <div class="content">
      <ng-content />
    </div>
  </div>
}
